import path from 'path';
import { getResolvePath as getResolvePathRocWeb } from 'roc-web';

/**
 * Used on the server to find all dependecies.
 *
 * When creating a extension of this project this needs to be extended.
 *
 * @param {...string} resolvePaths - Paths to be resolved.
 * @returns {string} Path that can be used with `Module._initPaths()`.
 */
export default function getResolvePath(...resolvePaths) {
    return getResolvePathRocWeb(path.join(__dirname, '..', '..', 'node_modules'), ...resolvePaths);
}
